const AFFORDABLE_HOUSING_COM_RENT_CAP_CENTS = 400_000;

export const AFFORDABLE_HOUSING_COM_OVER_CAP_TOOLTIP =
  "Listings over $4,000 per month cannot be syndicated to affordablehousing.com.";

export const isOverAffordableHousingComCap = (
  cents: number | null | undefined
): boolean => (cents ?? 0) > AFFORDABLE_HOUSING_COM_RENT_CAP_CENTS;
